import { Capacitor } from "@capacitor/core";
import { Geolocation } from "@capacitor/geolocation";
import { useCallback } from "react";

type GetGeolocation = () => Promise<{
  latitude: number | undefined;
  longitude: number | undefined;
}>;

export const useGetGeolocation = () =>
  useCallback<GetGeolocation>(
    () =>
      new Promise(async (resolve, reject) => {
        try {
          if (Capacitor.isPluginAvailable("Geolocation")) {
            const pos = await Geolocation.getCurrentPosition();
            resolve({
              latitude: pos.coords.latitude,
              longitude: pos.coords.longitude,
            });
            return;
          } else if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
              (pos) => {
                resolve({
                  latitude: pos.coords.latitude,
                  longitude: pos.coords.longitude,
                });
              },
              (error) => {
                reject(error);
              },
            );
            return;
          } else {
            reject(new Error("Geolocation is not available"));
          }
        } catch (error) {
          reject(error);
        }
      }),
    [],
  );
